import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl;

const API_URL = `${baseUrl}/api/indicador`; // Asegúrate que este URL coincida con el backend

// Servicio para guardar la ficha
export const FormularioService = async (data) => {
  try {
    const response = await axios.post(`${API_URL}`, data); // Endpoint para guardar el formulario
    console.log("Esta es la data del servicio front", data);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Servicio para eliminar la ficha
export const eliminarFichaService = async (indicadorId) => {
  try {
    const response = await axios.delete(`${API_URL}/${indicadorId}`); // Endpoint para eliminar la ficha
    console.log("Ficha eliminada con éxito, ID:", indicadorId);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Función para manejar errores de forma centralizada
const handleError = (error) => {
  if (error.response) {
    console.error('Error en la respuesta del servidor:', error.response.data);
  } else if (error.request) {
    console.error('No se recibió respuesta del servidor:', error.request);
  } else {
    console.error('Error al configurar la solicitud:', error.message);
  }
  throw error;
};
